module.exports = __webpack_public_path__ + "img/coupon_10.ba4458da.png";